import React, { useEffect, useRef, useState } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { Box, FormHelperText, Stack } from "@mui/material";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

import { Loader } from "../../common/loader";
import AlertDialog from "../../common/AlertDialog";
import CardSection from "../../common/StripeCardForm";
import SupportEmailLink from "../../common/SupportEmailLink";
import SecurePaymentPanel from "../../common/SecurePaymentPanel";
import Aurthorised from "../../../assets/price_F&Q/aurthorize.png";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import HubspotCookieBreakerInput from "../../common/HubspotCookieBreakerInput";
import TotalPyamentPopup from "../../user-signup/React-stripe/TotalPyamentPopup";
import CustomizedCheckbox from "../../common/customDesignedComponents/customCheckbox";
import { OrderSummaryBreakdown, hasAppliedPromoDiscount, isValidPaymentSummaryData } from "../../common/customDesignedComponents/OrderSummaryModal";
import { subscriptionAction } from "../../../redux/slices/subscription/subscriptionSlice";
import {
  currencyFormatter,
  findAllowedPrefixData,
  getObjLength,
  isServicerAddPropertyCheckout,
  persistStoredPromoCode as persistPromoHelper,
  clearStoredPromoCode as clearStoredPromoHelper,
  redirectToCustomerPropertiesForActiveMonitoring,
  resolveEnhancedMonitoringReportIds,
  resolveSignupBillingPrefillForCheckout,
  user_signup_details,
} from "../../helpers/utils";
import { attachEnhancedToCompleteUpgradeFlags } from "../../helpers/generatePropertySecurityQuestions";
import {
  DEFAULT_URL,
  LOCAL_RECORDING_FEES,
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_FORMAT,
} from "../../helpers/constants";
import {
  mapCreateUserApiUrl,
  mapPaymentApiUrl,
} from "../../for-service-provider/createUserApiPaths";
import { postAPIPayload } from "../../../apis/postApi";
import AdminCreateUserPayment from "./AdminCreateUserPayment";

const validationSchema = Yup.object().shape({
  first_name: Yup.string("Please enter your First Name.")
    .trim("The First name cannot include leading and trailing spaces")
    .strict(true)
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("First Name is required"),
  last_name: Yup.string("Please enter your Last name.")
    .trim("The Last name cannot include leading and trailing spaces")
    .strict(true)
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Last Name is required"),
  address: Yup.string("Please enter your Address.")
    .strict(true)
    .min(5, "Too Short!")
    .max(100, "Too Long!")
    .required("Address is required"),

  city: Yup.string("Please enter your City.")
    .strict(true)
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("City is required"),
  state: Yup.string("Please select the state").required("State is required"),
  zip: Yup.string("Please enter your Zip code.")
    .required("Zip is required")
    .matches(/^[0-9]{5}$/, "Zipcode must be exactly 5 digits"),
});

const FieldStyle = {
  borderRadius: "3px",
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

let MONTHLY_PLAN_PER_MONTH;
let MONTHLY_PLAN_FOR_BEGENING;
let YEARLY_PLAN_PER_MONTH;
let MONTHLY_PLAN_RECORDING_FEES;
let YEARLY_PLAN_RECORDING_FEES;

const CreditCardForm = ({
  mailingAddress,
  mailingData,
  stateCodesData,
  planDetails,
  onChangeModalScreen,
  finalAmount,
  onFinalAmountChange = () => {},
  onCloseModalHandler,
  setFromPropertyList = () => {},
  fromPropertyList,
  user_id = null,
  promoCode = undefined,
  selectedData = {},
  titleCompanyUser = {},
  category = "complete_protection",
  userEmail = undefined,
  isTailwindComponent = false,
  isServiceProvider = false,
  ownershipVerifiedViaId = false,
  ownershipVerificationAlreadyComplete = false,
  isResumeSignup = false,
  isAdminCreateUser = false,
  isAdmin = false,
  isUpgradeCategory = false,
  from = "",
  isEnhancedToCompleteProtection = false,
  isUserCreateProperty = false,
}) => {
  const [stripeErr, setStripeErr] = useState("");
  const [apiErr, setApiErr] = useState("");
  const [checked1, setChecked1] = useState(false);
  const [checkTerms, setCheckTerms] = useState(true);
  const [open, setOpen] = useState(false);
  const [paymentPayload, setPaymentPayload] = useState(false);
  const [finalAmountPopup, setFinalAmountPopup] = useState(false);
  const [dataflag, setDataFlag] = useState(false);
  const [valdiateModal, setValdiateModal] = useState(false);
  const [paymentSuccessModal, setPaymentSuccessModal] = useState(false);
  const [inlinePromoCode, setInlinePromoCode] = useState(
    () => localStorage.getItem("promoCode") || "",
  );
  const [appliedPromoCode, setAppliedPromoCode] = useState(() => {
    const stored = localStorage.getItem("promoCode") || "";
    return stored && hasAppliedPromoDiscount(finalAmount) ? stored : "";
  });
  const [promoMessage, setPromoMessage] = useState("");
  const [promoMessageIsError, setPromoMessageIsError] = useState(false);
  const [livePricingData, setLivePricingData] = useState(finalAmount);
  const dataflagRef = useRef(false);
  const promoApplyRef = useRef(false);
  const promoRemoveRef = useRef(false);

  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const isEnhancedMonitoring =
    category === "enhanced_monitoring" ? true : false;
  const getEnhancedMonitoringPaymentURL = (userId) =>
    isServiceProvider && userId
      ? `service-provider/customer/users/${userId}/payment-enhanced-monitoring`
      : "payment-enhanced-monitoring";

  const {
    createAccResponse,
    subscriptionPlans,
    paymentData,
    paymnetLoader,
    totalPayment,
    finalAmountPayload,
    totalPaymentDetails,
    getTotalAmountLoader,
    statesLoader,
    isPaymentDone,
    creditCardInfo,
    propertyIds,
    properties,
    investorsID,
    investorsPricingBreakdown,
    investorsPropertiesCount,
    investorsYearlyData,
    property_ids,
  } = useSelector((state) => state.signUpUser);
  const { threedSecurePayment } = useSelector((state) => state.subscription);
  // The property chosen in this flow (Add Property checks out only this one).
  const checkoutProperty = useSelector(
    (state) => state.properties?.selectedProperty,
  );
  const paymentFinalizedRef = useRef(false);
  console.log("selectedData==>", selectedData);

  const allowedPrefixObj =
    findAllowedPrefixData(
      localStorage.getItem("allowedPrefix") || selectedData?.source,
    ) || titleCompanyUser; //only for the assistant user creation flow

  const isFirstYearFreePricing = getObjLength(allowedPrefixObj)
    ? allowedPrefixObj?.isFirstYearFreePricing
    : false;

  const userIdFromSession = JSON.parse(localStorage.getItem("user_Id"));

  const resolvedUserId =
    (getObjLength(createAccResponse)
      ? createAccResponse.data?.user_id
      : userIdFromSession) || user_id;

  const getPaymentPropertyIds = () => {
    // Add Property pays only for the property added in it.
    if (
      isServicerAddPropertyCheckout({
        isServiceProvider,
        from,
        selectedProperty: checkoutProperty,
      })
    ) {
      return [checkoutProperty.property_id];
    }
    if (fromPropertyList && propertyIds?.length) {
      return propertyIds.filter(Boolean);
    }
    if (properties?.length) {
      return properties
        .map((property) => property?.property_id)
        .filter(Boolean);
    }
    return [];
  };

  // A service provider's checkout charges only the quoted properties (parcel
  // ids); without them the payment API charges every property of the client.
  const servicerPaymentPropertyIds = () => {
    if (!isServiceProvider) {
      return {};
    }
    const ids = getPaymentPropertyIds();
    return ids.length ? { property_id: ids } : {};
  };

  const getEnhancedMonitoringReportIds = () => {
    const fromSignupState = resolveEnhancedMonitoringReportIds({
      property_ids,
      propertyIds,
    });
    const hasReportIds = Array.isArray(fromSignupState)
      ? fromSignupState.length > 0
      : Boolean(fromSignupState);

    if (hasReportIds) {
      return fromSignupState;
    }

    // SP /clients/{uid} only: fall back to the selected workspace property.
    if (isServiceProvider && isAdminCreateUser) {
      const fromSelectedData =
        selectedData?.risk_report_id ?? selectedData?.id ?? null;
      if (fromSelectedData) {
        return [fromSelectedData];
      }
    }

    return fromSignupState;
  };

  const handleAchPayment = async (values, bankAccountId) => {
    const propertyIdList = getPaymentPropertyIds();
    if (!propertyIdList.length) {
      setApiErr("No property selected for payment.");
      return;
    }

    setOpen(true);
    const data = {
      ...values,
      plan: planDetails?.plan_id,
      step: 4,
      step_key: "PAYMENT",
      payment_mode: "ach",
      bank_account_id: bankAccountId,
      property_ids: propertyIdList,
      user_id: resolvedUserId,
      from_admin: true,
    };

    if (pc?.length > 0) {
      data.promo_code = pc;
    }
    if (rc?.length > 0) {
      data.referral_code = rc;
    }

    try {
      const response = await postAPIPayload({
        url: mapPaymentApiUrl(
          "post-ach-payment",
          resolvedUserId,
          isServiceProvider,
        ),
        data,
        token: true,
      });
      setOpen(false);
      if (response?.success) {
        setPaymentSuccessModal(true);
        setApiErr("");
      } else {
        setApiErr(
          response?.message ||
            response?.data?.message ||
            "Unable to process ACH payment.",
        );
      }
    } catch (error) {
      setOpen(false);
      setApiErr(error?.message || "Unable to process ACH payment.");
    }
  };

  const validateErr = (event) => {
    console.log("validate error==>", event);
    setStripeErr("");
  };

  const onChecked = (e) => {
    console.log("cjceked val==?", e.target.checked);
    setChecked1(e.target.checked);
    if (!e.target.checked) {
      setCheckTerms(e.target.checked);
    } else {
      setCheckTerms(true);
    }
  };

  const Callto = ({ phone, children }) => {
    return <a href={`tel:${phone}`}>{children}</a>;
  };

  let pc = localStorage.getItem("promoCode") || promoCode;
  let rc = localStorage.getItem("referralCode");

  const buildFinalAmountRequest = (promoCodeOverride = pc) => {
    if (!getObjLength(finalAmountPayload)) {
      return null;
    }

    let data = { ...finalAmountPayload };
    if (promoCodeOverride) {
      data.promo_code = promoCodeOverride;
    } else {
      delete data.promo_code;
    }

    let url = "get-final-amount";
    if (isEnhancedMonitoring) {
      url = "get-final-amount-enhanced-monitoring";
    }
    if (investorsID) {
      url = "investors-price-details";
      data = {
        user_id: resolvedUserId,
        property_id: propertyIds,
        promo_code: promoCodeOverride || undefined,
        plan_id: planDetails?.plan_id,
      };
    }

    return { url, data };
  };

  const creditCardClose = () => {
    console.log("creditCardInfo==>", creditCardInfo);
    if (creditCardInfo?.success) {
      cardPayment();
    }
    if (!creditCardInfo?.sucess) {
      setApiErr(creditCardInfo?.data?.message);
    }

    setOpen(false);
  };

  const handleSubmit = async (values) => {
    // event.preventDefault();
    setCheckTerms(checked1);
    console.log(!values.promo_code, "values==>>", values);
    if (!values.referral_code) {
      delete values.referral_code;
    }
    if (!values.promo_code) {
      delete values.promo_code;
    }

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }
    if (checked1) {
      setOpen(!open);
    }
    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);

    if (result.error) {
      console.error(result.error.message);
      setStripeErr(result.error.message);
      creditCardClose();
    } else {
      // handleToggle();
      setStripeErr("");
      let data = { ...values, step: 4, step_key: "SAVE_CREDIT_CARD" };
      data.token = result.token.id;
      data.user_id =
        (getObjLength(createAccResponse)
          ? createAccResponse.data?.user_id
          : userIdFromSession) || user_id;
      if (checked1) {
        cardPayment(data);
      }
    }
  };

  const cardPayment = (dd) => {
    const appliedPromo =
      localStorage.getItem("promoCode") || promoCode || dd?.promo_code || "";
    const appliedReferral =
      localStorage.getItem("referralCode") || dd?.referral_code || "";

    setOpen(true);
    let storedCar = {};
    try {
      storedCar = JSON.parse(localStorage.getItem("carEnrollment") || "{}");
    } catch {
      storedCar = {};
    }
    const data = {
      ...dd,
      plan: planDetails?.plan_id,
      step: 4,
      step_key: "PAYMENT",
      ...(appliedPromo ? { promo_code: appliedPromo } : {}),
      ...(appliedReferral ? { referral_code: appliedReferral } : {}),
      ...(storedCar.payment_plan ? { payment_plan: storedCar.payment_plan } : {}),
      ...(storedCar.revenue_share_choice
        ? { revenue_share_choice: storedCar.revenue_share_choice }
        : {}),
      ...(storedCar.car_agent_property_id
        ? { car_agent_property_id: storedCar.car_agent_property_id }
        : {}),
      ...(Array.isArray(storedCar.car_agent_property_ids)
        ? { car_agent_property_ids: storedCar.car_agent_property_ids }
        : {}),
      ...servicerPaymentPropertyIds(),
    };
    const paymentData = attachEnhancedToCompleteUpgradeFlags(data, {
      property: selectedData,
      forceUpgrade: Boolean(isEnhancedToCompleteProtection),
    });
    let paymentURL = mapCreateUserApiUrl(
      `admin/users/${paymentData?.user_id}/payment`,
      isServiceProvider,
    );
    if (isEnhancedMonitoring) {
      paymentData.report_id = getEnhancedMonitoringReportIds();
      paymentURL = getEnhancedMonitoringPaymentURL(paymentData?.user_id);
    }
    console.log(
      isEnhancedMonitoring,
      "PPP creditcard payment data==>",
      paymentData,
    );
    setPaymentPayload(paymentData);
    console.log(
      pc,
      "===",
      paymentData?.promo_code,
      "finalAmountPayload==>",
      finalAmountPayload,
    );
    if (appliedPromo || paymentData?.promo_code) {
      if (appliedPromo === paymentData?.promo_code) {
        dispatch(
          userSigupAction.getPayment({
            url: paymentURL,
            data: paymentData,
            token: true,
          }),
        );
      } else {
        setOpen(false);
        let paymnetData = { ...finalAmountPayload };
        // if (data?.promo_code?.length > 0) {
        paymnetData.promo_code = paymentData?.promo_code;
        // }

        // multiple properties added to paymnet
        if (
          fromPropertyList &&
          !isServicerAddPropertyCheckout({
            isServiceProvider,
            from,
            selectedProperty: checkoutProperty,
          })
        ) {
          paymnetData = {
            ...paymnetData,
            property_id: propertyIds,
            property_ids: properties,
          };
        }
        console.log("passed data==>", paymnetData);

        let url = "get-final-amount";
        if (isEnhancedMonitoring) {
          url = "get-final-amount-enhanced-monitoring";
        }
        // for investors when they add promocode
        if (investorsID) {
          url = "investors-price-details";
          paymnetData = {
            user_id: paymentData?.user_id,
            property_id: propertyIds,
            promo_code: paymentData?.promo_code,
            plan_id: paymentData?.plan,
          };
        }

        dispatch(
          userSigupAction.getTotalPaymentDetails({
            url: url,
            data: paymnetData,
          }),
        );
      }
    } else {
      setOpen(false);
      dispatch(
        userSigupAction.getPayment({
          url: paymentURL,
          data: paymentData,
          token: true,
        }),
      );
    }
  };

  const submitChanges = () => {
    const appliedPromoCode =
      localStorage.getItem("promoCode") ||
      paymentPayload?.promo_code ||
      promoCode ||
      null;
    const appliedReferralCode =
      localStorage.getItem("referralCode") || paymentPayload?.referral_code;

    let payload = {
      ...(paymentPayload || {}),
    };
    if (appliedPromoCode) {
      payload.promo_code = appliedPromoCode;
    } else {
      delete payload.promo_code;
    }
    if (appliedReferralCode) {
      payload.referral_code = appliedReferralCode;
    } else {
      delete payload.referral_code;
    }

    payload = attachEnhancedToCompleteUpgradeFlags(payload, {
      property: selectedData,
      forceUpgrade: Boolean(isEnhancedToCompleteProtection),
    });

    let paymentURL = mapCreateUserApiUrl(
      `admin/users/${payload?.user_id}/payment`,
      isServiceProvider,
    );
    if (isEnhancedMonitoring) {
      paymentURL = getEnhancedMonitoringPaymentURL(payload?.user_id);
      payload.report_id = getEnhancedMonitoringReportIds();
    }
    console.log("QQQ payload==>1", payload);
    dispatch(
      userSigupAction.getPayment({
        url: paymentURL,
        data: payload,
        token: true,
      }),
    );
    setFinalAmountPopup(false);
  };

  const clearStoredPromoCode = () => {
    localStorage.removeItem("promoCode");
    try {
      const planData = JSON.parse(localStorage.getItem("Plan_Data") || "{}");
      if (planData?.promo_code != null) {
        const { promo_code: _removed, ...rest } = planData;
        localStorage.setItem("Plan_Data", JSON.stringify(rest));
      }
    } catch {
      // ignore invalid Plan_Data
    }
  };

  const closePaymentErrorModal = () => {
    clearStoredPromoCode();
    setFinalAmountPopup(false);
    dispatch(userSigupAction.fetchTotalPaymentDetails({}));
  };

  const isAdminResumeEnhancedPayment =
    isResumeSignup && isEnhancedMonitoring && isAdminCreateUser;

  const pricingSummaryData = isValidPaymentSummaryData(livePricingData)
    ? livePricingData
    : isValidPaymentSummaryData(finalAmount)
      ? finalAmount
      : totalPaymentDetails?.success &&
          isValidPaymentSummaryData(totalPaymentDetails?.data)
        ? totalPaymentDetails.data
        : livePricingData && getObjLength(livePricingData)
          ? livePricingData
          : finalAmount && getObjLength(finalAmount)
            ? finalAmount
            : null;
  // Add Property / Add Subscription / Upgrade (customer or admin)
  const showAdminPricingBreakdown =
    Boolean(isUpgradeCategory) ||
    Boolean(isEnhancedToCompleteProtection) ||
    Boolean(isUserCreateProperty) ||
    from === "add-subscriptions" ||
    from === "add-property";
  const promoIsActive =
    hasAppliedPromoDiscount(pricingSummaryData) || Boolean(appliedPromoCode);

  const applyAdminPromoCode = () => {
    const code = inlinePromoCode.trim();
    if (!code) return;

    promoApplyRef.current = true;
    promoRemoveRef.current = false;
    setPromoMessage("");
    setPromoMessageIsError(false);

    let planData = {};
    try {
      planData = JSON.parse(localStorage.getItem("Plan_Data") || "{}");
    } catch {
      planData = {};
    }
    let data = { ...planData, promo_code: code };
    let url = "customer/get-final-amount";
    if (isEnhancedMonitoring) {
      url = "get-final-amount-enhanced-monitoring";
    }

    dispatch(userSigupAction.getTotalPaymentDetails({ url, data }));
  };

  const removeAdminPromoCode = () => {
    promoRemoveRef.current = true;
    promoApplyRef.current = false;
    clearStoredPromoHelper();
    setInlinePromoCode("");
    setAppliedPromoCode("");
    setPromoMessage("");
    setPromoMessageIsError(false);

    let planData = {};
    try {
      planData = JSON.parse(localStorage.getItem("Plan_Data") || "{}");
    } catch {
      planData = {};
    }
    const { promo_code: _removed, ...rest } = planData;
    try {
      localStorage.setItem("Plan_Data", JSON.stringify(rest));
    } catch {
      // ignore
    }
    let url = "customer/get-final-amount";
    if (isEnhancedMonitoring) {
      url = "get-final-amount-enhanced-monitoring";
    }
    dispatch(userSigupAction.getTotalPaymentDetails({ url, data: rest }));
  };

  const finalizeAdminPaymentSuccess = () => {
    if (paymentFinalizedRef.current) {
      return;
    }
    paymentFinalizedRef.current = true;

    dispatch(subscriptionAction.clear3dSecurePaymentData({}));
    localStorage.removeItem("promoCode");
    localStorage.removeItem("referralCode");
    setValdiateModal(false);
    setPaymentSuccessModal(false);
    setFinalAmountPopup(false);
    setOpen(false);
    onCloseModalHandler("success");
    setFromPropertyList(false);
    dispatch(
      userSigupAction.setPropertiesId({
        propertyIds: {},
        properties: {},
        ids: {},
      }),
    );
  };

  const onSuccessFun = () => {
    setOpen(false);
    setValdiateModal(true);
  };

  const onFailedFun = () => {
    setOpen(false);
    setValdiateModal(true);
    paymentFinalizedRef.current = false;
    console.log("failed on 3d payment");
  };

  const paymentDone = () => {
    finalizeAdminPaymentSuccess();
  };

  useEffect(() => {
    creditCardClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditCardInfo]);

  useEffect(() => {
    dataflagRef.current = dataflag;
  }, [dataflag]);

  useEffect(() => {
    if (isValidPaymentSummaryData(finalAmount)) {
      setLivePricingData(finalAmount);
    }
  }, [finalAmount]);

  useEffect(() => {
    console.log("totalPaymentDetails==>", totalPaymentDetails);
    if (!getObjLength(totalPaymentDetails)) {
      return;
    }

    const promoErrorMessage =
      totalPaymentDetails?.data?.message ||
      totalPaymentDetails?.message ||
      "Unable to apply promo code.";

    if (promoRemoveRef.current) {
      if (
        totalPaymentDetails?.success &&
        isValidPaymentSummaryData(totalPaymentDetails?.data)
      ) {
        const nextData = totalPaymentDetails?.data;
        promoRemoveRef.current = false;
        setPromoMessage("");
        setPromoMessageIsError(false);
        setAppliedPromoCode("");
        clearStoredPromoHelper();
        setLivePricingData(nextData);
        onFinalAmountChange(nextData);
        return;
      }
      promoRemoveRef.current = false;
      setPromoMessage(
        totalPaymentDetails?.data?.message ||
          totalPaymentDetails?.message ||
          "Unable to remove promo code.",
      );
      setPromoMessageIsError(true);
      return;
    }

    if (promoApplyRef.current) {
      promoApplyRef.current = false;
      const nextData = totalPaymentDetails?.data;
      const code = inlinePromoCode.trim();
      const discountApplied =
        totalPaymentDetails?.success && hasAppliedPromoDiscount(nextData);

      if (discountApplied && isValidPaymentSummaryData(nextData)) {
        if (code) {
          persistPromoHelper(code);
          setAppliedPromoCode(code);
        }
        setPromoMessage("Promo code applied.");
        setPromoMessageIsError(false);
        setLivePricingData(nextData);
        onFinalAmountChange(nextData);
        return;
      }

      clearStoredPromoHelper();
      setAppliedPromoCode("");
      setPromoMessage(promoErrorMessage);
      setPromoMessageIsError(true);
      return;
    }

    if (totalPaymentDetails?.success) {
      // Plan-screen Order Summary already confirmed this quote. Reuse it on
      // the payment page instead of opening the pricing modal again.
      if (isValidPaymentSummaryData(finalAmount)) {
        const nextData = isValidPaymentSummaryData(totalPaymentDetails?.data)
          ? totalPaymentDetails.data
          : finalAmount;
        setLivePricingData(nextData);
        onFinalAmountChange(nextData);
        return;
      }
      setFinalAmountPopup(true);
      setDataFlag(true);
      return;
    }

    const request = buildFinalAmountRequest();
    const hadPromo = Boolean(
      request?.data?.promo_code || localStorage.getItem("promoCode"),
    );

    // Order Summary already open → keep it so wrong-promo errors stay inline
    if (dataflagRef.current) {
      setFinalAmountPopup(true);
      setDataFlag(true);
      return;
    }

    // Initial load failed because of a bad promo → no error AlertDialog
    if (hadPromo) {
      clearStoredPromoCode();
      setFinalAmountPopup(false);
      setDataFlag(false);
      dispatch(userSigupAction.fetchTotalPaymentDetails({}));
      return;
    }

    setFinalAmountPopup(true);
    setDataFlag(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPaymentDetails]);

  useEffect(() => {
    if (getObjLength(paymentData)) {
      if (paymentData?.success) {
        if (paymentData?.data?.actionRequired) {
          setValdiateModal(false);
          setOpen(false);
          return;
        }
        if (
          (!paymentData?.data?.actionRequired &&
            paymentData?.data?.length === 0) ||
          category === "enhanced_monitoring"
        ) {
          setValdiateModal(true);
          setOpen(false);
          return;
        }
      } else {
        // Admin resume: stay on payment and show the error — do not redirect
        // to /properties (404 for admin sessions).
        if (
          !isAdminResumeEnhancedPayment &&
          redirectToCustomerPropertiesForActiveMonitoring(paymentData)
        ) {
          return;
        }
        setValdiateModal(true);
        setOpen(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData]);

  useEffect(() => {
    if (getObjLength(isPaymentDone)) {
      if (isPaymentDone?.success) {
        if (isPaymentDone?.data?.payment_status === "success") {
          setValdiateModal(true);
          return;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData]);

  const ss = Object.values(stateCodesData);
  const propertySearchData = (() => {
    try {
      const raw = localStorage.getItem("property_search_data");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();
  const isCarAgentCheckout =
    isServiceProvider &&
    isAdminCreateUser &&
    (localStorage.getItem("signup_source") === "car" ||
      Boolean(localStorage.getItem("car_portfolio_id")));
  const billingPrefill = isCarAgentCheckout
    ? {
        first_name: "",
        last_name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
      }
    : resolveSignupBillingPrefillForCheckout({
        mailingData,
        mailingAddress,
        propertySearchData,
        userSignupDetails: user_signup_details(),
        stateList: stateCodesData,
      });
  const stateValue = ss.filter(
    (e) => e === (billingPrefill.state || mailingAddress?.state),
  );

  if (getObjLength(subscriptionPlans) && subscriptionPlans?.success) {
    if ((subscriptionPlans?.data).length > 0) {
      const monthlyPlans = subscriptionPlans?.data?.find(
        (data) => data?.name === "Monthly",
      );
      const yearlyPlans = subscriptionPlans?.data?.find(
        (data) => data?.name === "Yearly",
      );
      MONTHLY_PLAN_PER_MONTH = monthlyPlans.recurring_amount;
      MONTHLY_PLAN_FOR_BEGENING = monthlyPlans.monthly_plan_for_begening;
      YEARLY_PLAN_PER_MONTH = yearlyPlans?.recurring_amount;
      MONTHLY_PLAN_RECORDING_FEES = true; //monthlyPlans.recording_fee;
      YEARLY_PLAN_RECORDING_FEES = true; //yearlyPlans?.recording_fee;
    }
  }

  const skipPostcardVerificationMessage =
    ownershipVerifiedViaId ||
    ownershipVerificationAlreadyComplete ||
    isServiceProvider;

  function successMsg() {
    return (
      <>
        <p className="text-success fw-500 mt-3">
          {/* {paymentData?.message} */}
          Congratulations!
        </p>
        <p>
          {skipPostcardVerificationMessage ? (
            <>
              EquityProtect will now start monitoring this property and begin
              the process of locking down the title. Your client will receive a
              welcome email with login instructions to create their security PIN
              and complete account setup.
            </>
          ) : (
            <>
              EquityProtect will now start monitoring your property and begin
              the process of locking down your title. In the meantime, watch
              your mail for a postcard that will be sent to your mailing
              address. This postcard is the final step in the verification
              process. Please follow the instructions and use the code on the
              postcard to finalize the process.
            </>
          )}
        </p>
      </>
    );
  }

  console.log("planDetails==>", planDetails);
  return (
    <>
      <SecurePaymentPanel
        displayLabel={false}
        cardData={null}
        paymentData={paymentData}
        onSuccessFun={onSuccessFun}
        onFailedFun={onFailedFun}
        cardList={false}
        // SP client checkout finishes 3DS for the client that was charged.
        userId={
          isServiceProvider && isAdminCreateUser
            ? resolvedUserId
            : getObjLength(createAccResponse)
              ? createAccResponse?.data?.user_id
              : userIdFromSession
        }
        successMsg={successMsg()}
        successClose={true}
        onSuccessModalClose={paymentDone}
        last_steps={{ step: 4, step_key: "PAYMENT" }}
        selectedCategory={category}
        userEmail={userEmail}
        isTailwindComponent={isTailwindComponent}
        isAdmin={isAdminCreateUser}
        isServiceProvider={isServiceProvider}
        isAdminCreateUser={isAdminCreateUser}
        setValdiateModal={setValdiateModal}
      />

      <Formik
        enableReinitialize
        validateOnChange
        initialValues={{
          first_name: billingPrefill.first_name || "",
          last_name: billingPrefill.last_name || "",
          address: isCarAgentCheckout
            ? ""
            : billingPrefill.address || mailingAddress?.address || "",
          city: isCarAgentCheckout
            ? ""
            : billingPrefill.city || mailingAddress?.city || "",
          state: isCarAgentCheckout
            ? ""
            : billingPrefill.state || stateValue[0] || "",
          zip: isCarAgentCheckout
            ? ""
            : billingPrefill.zip ||
              (mailingAddress?.zip != null
                ? String(mailingAddress.zip).slice(0, 5)
                : ""),
          referral_code: rc ? rc : null,
          promo_code: pc ? pc : null,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          setFieldValue,
          setFieldTouched,
          touched,
          errors,
          validateForm,
        }) => {
          if (isTailwindComponent) {
            return (
              <AdminCreateUserPayment
                values={values}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                touched={touched}
                errors={errors}
                validateForm={validateForm}
                stateOptions={ss}
                stripeErr={stripeErr}
                apiErr={apiErr}
                checked1={checked1}
                checkTerms={checkTerms}
                onChecked={(checked) => {
                  setChecked1(checked);
                  setCheckTerms(checked);
                }}
                onCardPayment={cardPayment}
                onAchPayment={handleAchPayment}
                submitting={open || paymnetLoader}
                userEmail={userEmail}
                userId={resolvedUserId}
                isServiceProvider={isServiceProvider}
                isResumeSignup={isResumeSignup}
                showAdminPricingBreakdown={showAdminPricingBreakdown}
                pricingSummaryData={pricingSummaryData}
                selectedCategory={category}
                showPromoCode={showAdminPricingBreakdown}
                promoCodeValue={inlinePromoCode}
                onPromoCodeChange={setInlinePromoCode}
                onApplyPromoCode={applyAdminPromoCode}
                onRemovePromoCode={removeAdminPromoCode}
                showRemovePromoCode={promoIsActive}
                promoApplying={getTotalAmountLoader}
                promoMessage={promoMessage}
                promoMessageIsError={promoMessageIsError}
                submitLabel={
                  isCarAgentCheckout ? "Start Protection" : "Start My Protection"
                }
                totalLabel={
                  isCarAgentCheckout ? "Total Due Today" : "Total due today"
                }
              />
            );
          }

          return (
            <Form id="credit-card-form" autoComplete="off">
              {/* Hubspot hidden input for cookie breaker */}
              <HubspotCookieBreakerInput
                userEmail={userEmail}
                isPropertyForm={true}
              />

              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid xs={12} md={12} px={1} pb={1} mb={2}>
                  <CardSection
                    stripeErr={stripeErr}
                    validateErr={validateErr}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    id="billing_first_name"
                    label="First Name"
                    name="first_name"
                    value={values?.first_name}
                    variant="outlined"
                    sx={FieldStyle}
                    inputProps={{ autoComplete: "billing given-name" }}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#0D120B",
                      },
                    }}
                    onChange={(event) => {
                      setFieldValue("first_name", event.target.value);
                    }}
                    helperText={touched.first_name && errors.first_name}
                    error={touched.first_name && Boolean(errors.first_name)}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    id="billing_last_name"
                    label="Last Name"
                    name="last_name"
                    variant="outlined"
                    sx={FieldStyle}
                    inputProps={{ autoComplete: "billing family-name" }}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#0D120B",
                      },
                    }}
                    value={values?.last_name}
                    onChange={(event) => {
                      setFieldValue("last_name", event.target.value);
                    }}
                    helperText={touched.last_name && errors.last_name}
                    error={touched.last_name && Boolean(errors.last_name)}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    id="billing_address"
                    label="Address"
                    name="address"
                    variant="outlined"
                    sx={FieldStyle}
                    inputProps={{ autoComplete: "billing address-line1" }}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#0D120B",
                      },
                    }}
                    value={values?.address}
                    onChange={(event) => {
                      setFieldValue("address", event.target.value);
                    }}
                    helperText={touched.address && errors.address}
                    error={touched.address && Boolean(errors.address)}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    id="billing_city"
                    label="City"
                    name="city"
                    value={values?.city}
                    variant="outlined"
                    sx={FieldStyle}
                    inputProps={{ autoComplete: "billing address-level2" }}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#0D120B",
                      },
                    }}
                    onChange={(event) => {
                      setFieldValue("city", event.target.value);
                    }}
                    helperText={touched.city && errors.city}
                    error={touched.city && Boolean(errors.city)}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <FormControl
                    fullWidth
                    className="sign-textField "
                    error={touched.state && Boolean(errors.state)}
                  >
                    <InputLabel
                      // id="demo-simple-select-placeholder"
                      label="State"
                    >
                      State
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-placeholder"
                      id="stateSelect"
                      value={values?.state}
                      label="State"
                      name="state"
                      variant="outlined"
                      onChange={(event) => {
                        setFieldValue("state", event.target.value);
                      }}
                      MenuProps={MenuProps}
                    >
                      {ss?.map((state, key) => (
                        <MenuItem value={state}>{state}</MenuItem>
                      ))}
                    </Select>
                    {touched.state && Boolean(errors.state) && (
                      <FormHelperText sx={{ color: "#d32f2f" }}>
                        {touched.state && errors.state}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    id="billing_zip"
                    label="Zip"
                    name="zip"
                    variant="outlined"
                    sx={FieldStyle}
                    inputProps={{ autoComplete: "billing postal-code" }}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#0D120B",
                      },
                    }}
                    value={values?.zip}
                    onChange={(event) => {
                      setFieldValue("zip", event.target.value);
                    }}
                    helperText={touched.zip && errors.zip}
                    error={touched.zip && Boolean(errors.zip)}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    id="promoCodeField"
                    label="Promo Code"
                    name="promo_code"
                    value={values?.promo_code}
                    variant="outlined"
                    sx={FieldStyle}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#00000075",
                      },
                      shrink: true,
                    }}
                    placeholder={"Optional"}
                    onChange={(event) => {
                      setFieldValue("promo_code", event.target.value);
                    }}
                    // helperText={touched.promo_code && errors.promo_code}
                    // error={touched.promo_code && Boolean(errors.promo_code)}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1} pb={1}>
                  <TextField
                    className="sign-textField "
                    // id="outlined-basic"
                    id="referralCodeField"
                    label="Referral Code"
                    name="referral_code"
                    value={values?.referral_code}
                    variant="outlined"
                    sx={FieldStyle}
                    InputLabelProps={{
                      style: {
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#00000075",
                      },
                      shrink: true,
                    }}
                    placeholder={"Optional"}
                    onChange={(event) => {
                      setFieldValue("referral_code", event.target.value);
                    }}
                    // helperText={touched.referral_code && errors.referral_code}
                    // error={touched.referral_code && Boolean(errors.referral_code)}
                  />
                </Grid>
              </Grid>
              {apiErr && (
                <>
                  <p className="text-danger text-center mt-3">{apiErr}</p>
                </>
              )}
              <Box textAlign={"start"} py={5} px={1}>
                <Stack
                  direction={"column"}
                  spacing={1}
                  justifyContent={"flex-start"}
                  alignItems={"start"}
                >
                  <Stack
                    direction={"row"}
                    className={!checkTerms && "border border-danger p-2"}
                  >
                    <span className="pt-1">
                      <CustomizedCheckbox onChecked={onChecked} />
                    </span>
                    <span>
                      By checking this box, you are agreeing to the terms below,
                      including EquityProtect's Subscription and Automatic
                      Renewal Payment Authorization terms and{" "}
                      <a
                        // href={`${DEFAULT_URL}api/service_agreement_2023.pdf`}
                        href={`${DEFAULT_URL}terms`}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Terms and Conditions
                      </a>{" "}
                      of Use. For Complete Protection, a local title or legal
                      partner in your county may prepare and record the UCC on
                      EquityProtect&apos;s behalf; they do not receive your card
                      or payment access. You may request internal-only recording
                      after purchase from the UCC recording preference on your
                      Properties page.
                    </span>
                  </Stack>
                  {!checkTerms && (
                    <p className="m-0 px-0 text-center text-danger">
                      Please select given terms to proceed further.
                    </p>
                  )}
                  <br />
                  <span>
                    Subscription & Automatic Renewal Payment Authorization. The
                    subscription begins when your purchase is completed, and it
                    will automatically renew before each renewal period (plus
                    applicable state taxes). By subscribing, you authorize us to
                    automatically charge your payment method the applicable
                    renewal price (plus applicable state taxes) before each
                    renewal, unless you cancel through your account dashboard,
                    or contact{" "}
                    <SupportEmailLink
                      email={SUPPORT_EMAIL}
                      text={SUPPORT_EMAIL}
                    />
                    , or call{" "}
                    <Callto phone={`${SUPPORT_PHONE}`}>
                      {SUPPORT_PHONE_FORMAT}
                    </Callto>
                  </span>
                </Stack>
              </Box>
              {showAdminPricingBreakdown ? (
                <Box px={1} pb={2} className="tailwind_component">
                  <OrderSummaryBreakdown
                    paymentData={pricingSummaryData}
                    category={category}
                    showPromoCode
                    promoCodeValue={inlinePromoCode}
                    onPromoCodeChange={setInlinePromoCode}
                    onApplyPromoCode={applyAdminPromoCode}
                    onRemovePromoCode={removeAdminPromoCode}
                    showRemovePromoCode={promoIsActive}
                    promoApplying={getTotalAmountLoader}
                    promoMessage={promoMessage}
                    promoMessageIsError={promoMessageIsError}
                  />
                </Box>
              ) : null}
              <Row className="d-flex align-items-center justify-content-center mt-5 break-word">
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={5}
                  xl={5}
                  className="stepBtn pt-3 text-center"
                >
                  <Button
                    disabled={!stripe}
                    type="submit"
                    className="next_button"
                    variant="contained"
                  >
                    Start My Protection
                  </Button>
                </Col>
                {isEnhancedMonitoring ? null : (
                  <Col xs={12} sm={12} md={12} lg={7} xl={7}>
                    {isFirstYearFreePricing ? null : planDetails?.name ===
                      "Monthly" ? (
                      <>
                        <p className="para mb-0 activation_text font_16">
                          You selected the Monthly Subscription for
                          <span className="fw-900 price_clr">
                            {" "}
                            ${MONTHLY_PLAN_PER_MONTH / 100}
                          </span>{" "}
                          per month + {""}
                          <span className="fw-900 price_clr">
                            $
                            {planDetails?.setup_fees_actual ||
                              planDetails?.setup_fees}
                          </span>{" "}
                          Setup fee for the first year.
                        </p>
                        <p className="para mb-0 activation_text font_16">
                          {/* <span className="fw-900 price_clr">
                          {currencyFormatter(LOCAL_RECORDING_FEES)}{" "}
                        </span> */}
                          {MONTHLY_PLAN_RECORDING_FEES &&
                            "You have to pay applicable sales tax + applicable Deposit for recording fees (One time fee)"}
                        </p>
                        <p className="para mb-0 mt-3 activation_text font_16">
                          Your card will be charged{" "}
                          <span className="fw-900 price_clr">
                            ${MONTHLY_PLAN_FOR_BEGENING}
                          </span>{" "}
                          once your subscription begins then{" "}
                          <span className="fw-900 price_clr">
                            ${MONTHLY_PLAN_PER_MONTH / 100}
                          </span>{" "}
                          each month there after. This will apply for each
                          property we have under our custodian.
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="para mb-0 activation_text font_16">
                          You selected the Annual Subscription for{" "}
                          {parseFloat(planDetails?.setup_fees) > 0 ? (
                            <>
                              <span className="fw-900 price_clr">
                                $
                                {(investorsID
                                  ? investorsYearlyData?.amount
                                  : planDetails?.amount) / 100}
                              </span>{" "}
                              per year +{" "}
                              <span className="fw-900 price_clr">
                                ${planDetails?.setup_fees}
                              </span>{" "}
                              Setup fee for the first year
                            </>
                          ) : (
                            <>
                              <span className="fw-900 price_clr">
                                $
                                {(
                                  (investorsID
                                    ? investorsYearlyData?.amount
                                    : planDetails?.amount) / 100
                                )?.toFixed(2)}
                              </span>{" "}
                              for the first year
                            </>
                          )}{" "}
                          and then{" "}
                          <span className="fw-900 price_clr">
                            $
                            {(investorsID
                              ? investorsYearlyData?.recurring_amount
                              : YEARLY_PLAN_PER_MONTH) / 100}
                          </span>{" "}
                          each following year.
                        </p>
                        <p className="para mb-0 activation_text font_16">
                          {/* <span className="fw-900 price_clr">
                          &nbsp;{currencyFormatter(LOCAL_RECORDING_FEES)}&nbsp;
                        </span> */}
                          {(investorsID
                            ? investorsYearlyData?.recording_fee
                            : YEARLY_PLAN_RECORDING_FEES) &&
                            "  You have to pay applicable sales tax +   applicable Deposit for recording fees (One time fee)"}
                        </p>
                        <p className="para mt-3 mb-0 activation_text font_16">
                          Your card will be charged{" "}
                          <span className="fw-900 price_clr">
                            {" "}
                            $
                            {(
                              (investorsID
                                ? investorsYearlyData?.amount
                                : planDetails?.amount) / 100
                            )?.toFixed(2)}
                          </span>{" "}
                          once your subscription begins. This will apply for
                          each property we have under our custodian.
                        </p>
                      </>
                    )}
                    <p
                      className={`para ${
                        !isFirstYearFreePricing && "mt-3"
                      } mb-0 activation_text font_16`}
                    >
                      Total amount will be deducted from your credit card is{" "}
                      <span className="fw-900 price_clr">
                        $
                        {investorsID
                          ? investorsPricingBreakdown?.total
                          : totalPayment?.data?.total || finalAmount?.total}
                      </span>{" "}
                      for{" "}
                      <span className="fw-900 price_clr">
                        {investorsID
                          ? investorsPropertiesCount
                          : totalPayment?.data?.no_of_properties}
                      </span>{" "}
                      {(investorsID
                        ? investorsPropertiesCount
                        : totalPayment?.data?.no_of_properties) > 1
                        ? "properties"
                        : "property"}{" "}
                      you've added.
                    </p>
                  </Col>
                )}
              </Row>
            </Form>
          );
        }}
      </Formik>

      {getObjLength(paymentData) && !paymentData?.success && !valdiateModal && (
        <>
          <p className="text-danger text-center mt-4">
            {paymentData?.data?.message}
          </p>
        </>
      )}

      {getObjLength(paymentData) && valdiateModal && !paymentData?.success && (
        <AlertDialog
          type="Error"
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            setValdiateModal(false);
            paymentFinalizedRef.current = false;
            dispatch(userSigupAction.fetchPaymentData({}));
          }}
          mesage={
            paymentData?.data?.message ||
            paymentData?.message ||
            "Unable to complete Enhanced Monitoring payment."
          }
          isTailwindComponent={isTailwindComponent}
          footer={false}
        />
      )}

      {!mailingData?.success && (
        <>
          <p className="text-danger text-center">{mailingData?.message}</p>
        </>
      )}
      {!isTailwindComponent && (
        <Box className="text-center mt-5">
          <Button
            variant="contained"
            className="popup_Btn other_popup_btn"
            onClick={() => {
              const storedPlan =
                localStorage.getItem("add_subscription_category") || category;
              const returnToAddSubscription =
                Boolean(isUserCreateProperty) &&
                storedPlan !== "complete_protection";
              onChangeModalScreen(
                returnToAddSubscription
                  ? "categoryWisePricing"
                  : "subscriptions",
              );
              setFinalAmountPopup(false);
              dispatch(userSigupAction.fetchTotalPaymentDetails({}));
            }}
          >
            Go Back
          </Button>
        </Box>
      )}

      {getObjLength(paymentData) &&
        valdiateModal &&
        paymentData?.success &&
        !paymentData?.data?.actionRequired &&
        !(
          getObjLength(threedSecurePayment) && !threedSecurePayment?.success
        ) && (
          <AlertDialog
            type="Success"
            openPopup={true}
            onClose={true}
            onCloseFun={paymentDone}
            mesage={successMsg()}
            isTailwindComponent={isTailwindComponent}
            footer={false}
          />
        )}

      {paymentSuccessModal && (
        <AlertDialog
          type="Success"
          openPopup={true}
          onClose={true}
          onCloseFun={paymentDone}
          mesage={successMsg()}
          isTailwindComponent={isTailwindComponent}
          footer={false}
        />
      )}

      {/* if paymnet process interrupt */}
      {getObjLength(isPaymentDone) &&
        valdiateModal &&
        isPaymentDone?.success &&
        isPaymentDone?.data?.payment_status === "success" && (
          <AlertDialog
            type="Success"
            openPopup={true}
            onClose={true}
            onCloseFun={paymentDone}
            mesage={successMsg()}
            isTailwindComponent={isTailwindComponent}
            footer={false}
          />
        )}

      <Loader
        open={open || paymnetLoader || statesLoader}
        message={
          "Do not close browser or reload the page while making payment."
        }
      />
      {!isTailwindComponent && (
        <>
          <hr />
          <div className="text-center mt-3 mb-0 w-100">
            <img src={Aurthorised} alt="Aurthorised" />
          </div>
        </>
      )}

      {/* When promocode has changed */}
      {finalAmountPopup &&
        (dataflag ? (
          <TotalPyamentPopup
            dataflag={dataflag}
            setDataFlag={setDataFlag}
            alert={finalAmountPopup}
            setAlert={setFinalAmountPopup}
            closePopup={(action) => {
              if (action === "cancel") {
                dispatch(userSigupAction.fetchTotalPaymentDetails({}));
              }
              setFinalAmountPopup(false);
            }}
            planDetails={planDetails}
            isClose={true}
            paySecure={submitChanges}
            investor_id={investorsID}
            isTailwindComponent={isTailwindComponent}
            showPromoCode={isTailwindComponent}
            finalAmountRequest={buildFinalAmountRequest()}
          />
        ) : (
          <AlertDialog
            type="Error"
            openPopup={finalAmountPopup}
            onClose={true}
            onCloseFun={closePaymentErrorModal}
            mesage={totalPaymentDetails?.data?.message}
            buttons={
              <Stack spacing={2} direction={"row"} justifyContent={"center"}>
                <Button
                  className="popup_Btn error_popup_btn m-2"
                  onClick={closePaymentErrorModal}
                >
                  cancel
                </Button>
              </Stack>
            }
          />
        ))}
    </>
  );
};

export default CreditCardForm;
